var App = App || {};

App.ComponentSsFeaturesScroll = (function ($) {
    'use strict';

    function init() {

        $(".component-ssFeaturesScroll").each(function () {
            const component = $(this);
            Carousel(component);
        });
    }

    function Carousel(component)
    {
        const buttons = component.find(".component-ssFeaturesScroll-desktop button");
        const carousel = component.find(".component-ssFeaturesScroll-carousel");
        
        const splide = new Splide(carousel.find(".splide")[0], {
            type: "loop",
            perPage: 1
        });

        splide.on("mounted", function () {

            var activeSlide = splide.Components.Slides.getAt(splide.index).slide;
            Update(component, activeSlide);

            buttons.on("click", function () {
                const id = $(this).data("id");
                const slide = carousel.find(`.splide__slide:not(.splide__slide--clone)[data-id="${id}"]`);
                const index = splide.Components.Elements.slides.findIndex(s => s === slide.get(0));
                splide.go(index);
            });
        });

        splide.on("move", function (next) {
            const slide = splide.Components.Slides.getAt(next).slide;
            Update(component, slide)
        });


        splide.mount({});
    }

    function Update(component, slide)
    {
        const buttons = component.find(".component-ssFeaturesScroll-desktop button");
        const imageBg = component.find(".component-ssFeaturesScroll-image-bg");
        const imageScreen = component.find(".component-ssFeaturesScroll-image-screen").children("img");

        const button = buttons.toArray().find(button => button.getAttribute("data-id") == slide.getAttribute("data-id"));
        const color = button.getAttribute("data-color");
        const scroll = imageScreen.height() * -(button.getAttribute("data-scroll") / 100);

        imageBg.attr("data-color", color);
        imageScreen.animate({ top: scroll }, 200);

        buttons.toArray().forEach(button => {
            button.setAttribute("aria-selected", button.getAttribute("data-id") == slide.getAttribute("data-id"));
        });
    }


    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ComponentSsFeaturesScroll.init();
});